var tag1 = "";
var tag2 = "Alupave Aluminium Decking Calc";
var tag3 = "Alukap-XR Roof Calc";
var rfnm = 1;
var collection1 = 0;
var collection2 = 0;
var lntha = 0;
var lnthb = 0;
var lnthc = 0;
var lnthd = 0;
var maxlen = 0;
var double = 1;
var quantity = 1;
var sheets = 1;
var clrcart = 0;
var products = [];
var products1 = [];
var products2 = [];
var colours1 = [];
var colours2 = [];
var colour1 = 'Grey';
var colour2 = '#58595b';
var multiplier = 1;
var direction = 'North';
var ttl = 'PRODUCT1';
var mycart = [];
var newcart = [];
var citems = [];
var mcaheaders = {method: 'get', headers: new Headers({'Authorization': 'Token 56e79298c2a7bf646d367522b3e2350ee6841de1','Content-Type': 'application/x-www-form-urlencoded'})};
var apiurl = 'https://myclearamber.com/mycapi/v1/cashop/';
if("cas.grokurv.co.uk" == window.location.hostname){
  var apiurl = 'https://myclearamber.com/mycapi/v1/cashopDev/';
}
$(".roofcal .roofimg").click(function(){
  	tag1 = $(this).attr('title');
  	rfnm = $(this).attr('key');
    var image = $(this).find('img').attr('src');
    var img = tag1.replaceAll('– ','');
    img = img.replaceAll(' ','_')+"_"+rfnm;
    image = image.replace(img,"Axiome_"+img+"_"+colour1);
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
  	$('.roofsheet img').attr('src',image);
  	$('.roofsheet img').attr('key',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('src',image);
  	$('.roofsize img').attr('key',$(this).find('img').attr('src'));
  	collection11();
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
});

$(".roofcal .yrc").click(function(){
  	if(tag1 == ''){ return false; }
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
})

function collection11(){
  	var colfltr = tag1+" || "+tag2;
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json()).then(data => {
          collection1 = data['results'][0];
          products = data['results'];
          return data 
      });
}

$('select[name="colour1"]').change(function(){
  	clearCart();
  	newcart = [];
  	colour1 = $(this).val();
    if (colour1 == 'Grey') { colour2 = '#58595b'; }
    if (colour1 == 'Mill') { colour2 = '#bcbec0'; }
    if (colour1 == 'Sand') { colour2 = '#D2A869'; }
    if (colour1 == 'RAL Colour') { colour2 = '#5a3826'; }
  	$('.roofselect button').attr('disabled',false);
    var img = $('.roofsheet img').attr('key').replaceAll('jpg','png').replaceAll('NoColour','Blank').replaceAll('Shape','Shaped');
    $(".roofsheet img, .roofsize img").css('background',colour2);
  	$(".roofsheet img, .roofsize img").attr("src",img);
    dirchange();
})

$('select[name="direction"]').change(function(){
    dirchange();
})

function dirchange(){
    direction = $('select[name="direction"]').val();
    var dir = "Up Dir";
    if (direction == 'South'){ dir = "Down Dir"; }
    if (direction == 'West'){ dir = "Left Dir"; }
    if (direction == 'East'){ dir = "Right Dir"; }
    var img = $('.roofsheet img').attr('key').replaceAll('jpg','png').replaceAll('NoColour','Blank').replaceAll('Shape','Shaped').replaceAll('NoDims','Dims').replaceAll('NoDir',dir);
    if (colour1 == 'RAL Colour'){
      img = img.replaceAll('Blank','RAL');
    }else{
      img = img.replaceAll('RAL','Blank');
    }
    $(".roofsheet img, .roofsize img").attr("src",img);
    clearCart();
}

$('.rfsize').click(function(){
    if(tag1 == 'Square Decking Area' || tag1 == 'Rectangle Decking Area'){
      	$('.extra').hide();
    }else{
    	$('.extra').show();
    }
    if(colour1 == ''){
      alert("Please select Colours First?");
      return false;
    }
  	$('.rooftype').hide();
  	$('.roofsheet').hide();
  	$('.roofsize').show();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor, .roofcal .number.yrc").addClass("complete");
  	$(".roofcal .number.cyrs").addClass("current");
})

$('.srtype').click(function(){
	$('.rooftype').show();
  	$('.roofsheet').hide();
  	$('.roofsize').hide();
  	$('.products').html('').hide();
  	$('.colour1, .colour2').hide();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("current");
    clearCart();
})

$('.ckit').click(function(){
  	$(this).attr("disabled","disabled");
  	clearCart();
  	lntha = parseInt($('.roofinput input[name="lengtha"]').val());
  	lnthb = parseInt($('.roofinput input[name="lengthb"]').val());
  	lnthc = parseInt($('.roofinput input[name="lengthc"]').val());
  	lnthd = parseInt($('.roofinput input[name="lengthd"]').val());
  	if(lntha < 99 || lnthb < 99){
    	alert("Please enter the valid length and width");
        $(this).attr("disabled",false);
      	return false;
    }
    if(lntha <= lnthc || lnthb <= lnthd){
      alert("Please enter the valid length for C and D");
      $(this).attr("disabled",false);
      return false;
    }
    if (direction == 'East' || direction == 'West') {
      swapeab();
      swapecd();
    }
    calculations();
  	// updateCart();
})

function calculations(){
  for (let p = 0; p < products.length; p++) {
    var tgstr = JSON.stringify(products[p]['tags']);
    if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9).replace(' ','') }
    multiplier = Math.ceil(lntha/147);
    if (tag1 == 'L-Shaped Decking Area' || tag1 == 'J-Shaped Decking Area' || tag1 == 'U-Shaped Decking Area' || tag1 == 'Hoop-Shaped Decking Area'){
      multiplier = Math.ceil((lntha-lnthd)/147);
    }
    if (ttl == 'PRODUCT1'){
      prodcal(products[p]);
      if (tag1 == 'L-Shaped Decking Area' || tag1 == 'J-Shaped Decking Area' || tag1 == 'U-Shaped Decking Area' || tag1 == 'Hoop-Shaped Decking Area') {
         multiplier = Math.ceil(lnthd/147);
         prodcal(products[p],Math.abs(lnthb-lnthc)); 
      }
      
    }
    if (ttl == 'PRODUCT2'){
      let lnt = lntha;
      if (tag1 == 'L-Shaped Decking Area' && direction == 'East') {lnt=lnthb;}
      if (tag1 == 'L-Shaped Decking Area' && direction == 'North') {lnt=lntha+lnthc;}
      if (tag1 == 'L-Shaped Decking Area' && direction == 'West') {lnt=lnthb+lnthd;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'East') {lnt=lnthb+lnthd;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'North') {lnt=lntha+lnthc;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'West') {lnt=lnthb;}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'North') {lnt=lntha+lnthd;}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'East') {lnt=lnthb+lnthc;}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'West') {lnt=lnthb+lnthc;}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'South') {lnt=lntha+lnthd;}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'North') {lnt=lntha+(2*lnthc);}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'East') {lnt=lnthb+lnthc;}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'West') {lnt=lnthb+lnthc;}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'South') {lnt=lntha;}
      prodcal(products[p], lnt, 1);
    }
    if (ttl == 'PRODUCT3'){
      lntht = lntha+(2*lnthb);
      if (tag1 == 'L-Shaped Decking Area' && direction == 'North') {lnt=2*lnthb+lntha-lnthc;}
      if (tag1 == 'L-Shaped Decking Area' && direction == 'East') {lnt=2*lntha+lnthb-lnthd;}
      if (tag1 == 'L-Shaped Decking Area' && direction == 'West') {lnt=2*lntha+lnthb;}
      if (tag1 == 'L-Shaped Decking Area' && direction == 'South') {lnt=2*lnthb+lntha;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'North') {lnt=2*lnthb+lntha-lnthc;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'East') {lnt=2*lntha+lnthb;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'West') {lnt=2*lntha+lnthb-lnthd;}
      if (tag1 == 'J-Shaped Decking Area' && direction == 'South') {lnt=2*lnthb+lntha;}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'North') {lnt=(lntha+lnthd)+(2*lnthb)+(2*lnthc);}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'East') {lnt=(lnthb+lnthc)+(2*lntha)+(2*lnthd);}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'West') {lnt=(lnthb+lnthc)+(2*lntha)+(2*lnthd);}
      if (tag1 == 'Hoop-Shaped Decking Area' && direction == 'South') {lnt=(lntha+lnthd)+(2*lnthb)+(2*lnthc);}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'North') {lnt=lntha+(2*lnthb);}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'East') {lnt=lntha+lnthb+lnthc+lnthd;}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'West') {lnt=lntha+lnthb+lnthc+lnthd;}
      if (tag1 == 'U-Shaped Decking Area' && direction == 'South') {lnt=lntha+(2*lnthb)+(2*lnthc);}
      prodcal(products[p], lntht, 1);
    }
    if (ttl == 'PRODUCT4'){
      // console.log("Product 4 Calculation");
    }
    if (ttl == 'PRODUCT5'){
      var qty = 0;
      if (tag1 == 'L-Shaped Decking Area' && (direction == 'South' || direction == 'West')) { qty = 1; }
      if (tag1 == 'J-Shaped Decking Area' && (direction == 'South' || direction == 'West')) { qty = 1; }
      // if (tag1 == 'U-Shaped Decking Area' && direction == 'North') { qty = 2; }
      newcart.push({"sno":ttl, "quantity":qty, "product":products[p]['id'], "title":products[p]['variants'][0]['title'], "variant":products[p]['variants'][0]['vid'], "sku":products[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
    }
    if (ttl == 'PRODUCT6'){
      var qty = 0;
      if (tag1 == 'L-Shaped Decking Area' && (direction == 'North' || direction == 'East')) { qty = 1; }
      if (tag1 == 'J-Shaped Decking Area' && (direction == 'North' || direction == 'West')) { qty = 1; }
      if (tag1 == 'U-Shaped Decking Area' && direction == 'North') { qty = 2; }
      newcart.push({"sno":ttl, "quantity":qty, "product":products[p]['id'], "title":products[p]['variants'][0]['title'], "variant":products[p]['variants'][0]['vid'], "sku":products[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
    }
    if (ttl == 'PRODUCT7'){
      var qty = 1;
      if (tag1 == 'U-Shaped Decking Area' || tag1 == 'Hoop-Shaped Decking Area') { qty = 2; }
      for (let v = 0; v < products[p]['variants'].length; v++){
        if(products[p]['variants'][v]['title'].indexOf(colour1) == 0){
          newcart.push({"sno":ttl, "quantity":qty, "product":products[p]['id'], "title":products[p]['variants'][v]['title'], "variant":products[p]['variants'][v]['vid'], "sku":products[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
        }
      }
    }
  }
  updateCart();
}

function prodcal(prod, lnthf=Math.abs(lnthb), multi=Math.abs(multiplier)){
    console.log(lntha, lnthb, lnthf, ttl, prod['options']);
    let noptions = prod['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
    noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
    if (colour1 == 'Sand' && noptions[0]==1000) {
      noptions.splice(0, 1);
    }
    // console.log(noptions, colour1, prod['options'][1]['values']);
    var idx = noptions[noptions.length-1];
    var nidx = 0;
    for (let j = 0; j < noptions.length; j++) {
      if(lnthf%idx <= noptions[j]){ idx = noptions[j]; nidx=j; break; }
    }
    idx = Number(idx/1000).toFixed(1);
    // console.log(nidx, idx, noptions, colour1);
    if (lnthf >= noptions[noptions.length-1]) {
      var title = colour1 + ' / '+Number(noptions[noptions.length-1]/1000).toFixed(1)+'m';
      for (let v = 0; v < prod['variants'].length; v++) {
        if (prod['variants'][v]['title'] == title) {
          var qty = Math.ceil(lnthf/noptions[noptions.length-1])-1;
          if(lnthf%noptions[noptions.length-1] == 0){ qty += 1;}
          newcart.push({"sno":ttl, "quantity":qty*multi, "product":prod['id'], "title":prod['variants'][v]['title'], "variant":prod['variants'][v]['vid'], "sku":prod['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          break;
        }
      }
    }
    var title = colour1 + ' / '+idx+'m';
    for (let v = 0; v < prod['variants'].length; v++) {
      if (prod['variants'][v]['title'] == title && lnthf%noptions[noptions.length-1] != 0) {
        newcart.push({"sno":ttl, "quantity":1*multi, "product":prod['id'], "title":prod['variants'][v]['title'], "variant":prod['variants'][v]['vid'], "sku":prod['variants'][v]['sku'], "class":"WIDTH", "tag":2});
        break;
      }
    }
}

function updateCart(){
    console.log("New Cart Items =", newcart);

    function sortProducts(data) {
      return data.sort((a, b) => {
        const numA = parseInt(a.sno.replace("PRODUCT", ""), 10);
        const numB = parseInt(b.sno.replace("PRODUCT", ""), 10);
        return numA - numB;
      });
    }
    const sortedData = sortProducts(newcart);
    // Add Product to Cart
    if (direction == 'East' || direction == 'West') {
      swapeab();
      swapecd();
    }
    citems = [];
    var qty4 = -1;
    var pidx = 0;
    for(let c=0; c<sortedData.length; c++){
      if (JSON.stringify(citems).indexOf(sortedData[c]['variant']) > 0){
        for (let v = 0; v < citems.length; v++) {
          if (citems[v]['id']) { citems[v]['quantity'] = citems[v]['quantity']+sortedData[c]['quantity']; }
        }
      }else{
        citems.push({"quantity":sortedData[c]['quantity'], "id":sortedData[c]['variant'], properties: {"Title":sortedData[c]['title'], "ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":sortedData[c]['sno'] }});
      }
      if (sortedData[c]['sno'] == 'PRODUCT2'){
        for (let p = 0; p < products.length; p++) {
          var tgstr = JSON.stringify(products[p]['tags']);
          if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9).replace(' ','') }
          if (ttl == 'PRODUCT4'){
            pidx = p;
            qty4 = qty4+sortedData[c]['quantity'];
            // citems.push({"quantity":sortedData[c]['quantity']-1, "id":products[p]['variants'][0]['vid'], properties: {"Title":products[p]['variants'][0]['title'], "ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":ttl }}); 
          }
        }
      }
    }
    citems.push({"quantity":qty4, "id":products[pidx]['variants'][0]['vid'], properties: {"Title":products[pidx]['variants'][0]['title'], "ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":ttl }});

    citems.reverse();
    console.log("New Cart Items =", citems);
    // duplicates();

    myInterval = setInterval(function () {
      if(clrcart == 0){
        jQuery.post('/cart/add.js', {
          items: citems
        }).then(data => {
          $(".ckit").attr("disabled",false);
          // window.location.href = '/cart';
          if(window.location.pathname.indexOf('fr-fr') == 1){ window.location.href = '/fr-fr/cart'; }else{ window.location.href = '/cart'; }
        });
        clearInterval(myInterval);
      }else{
          // console.log(clrcart);
      }
    }, 800);
}

function duplicates() {
  // console.log(JSON.stringify(citems));
  for(let i=0;i<citems.length;i++){
    // console.log(JSON.stringify(citems).indexOf(citems[i]['id']), citems[i]['id']);
    console.log(citems.indexOf(citems[i]), citems[i]['id']);
  }
}

function swapeab() {
  let temp = lntha;
  lntha = lnthb;
  lnthb = temp;
}

function swapecd() {
  let temp = lnthc;
  lnthc = lnthd;
  lnthd = temp;
}

function clearCart(){
  	clrcart = 1;
  	newcart = [];
	$.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
//             Shopify.clear();
          clrcart = 0;
        },
        error: function(XMLHttpRequest, textStatus) {
          clrcart = 0;
          console.log("Clear Cart Error");
          /* error code */
        }
      });
}